import { Box, Stack, Typography } from '@mui/joy';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PreviewImportTable } from 'bom/components';
import { ImportHeader, ImportType } from 'bom/enums';
import { Button } from 'chatbot/components';
import { IChatbotPart } from 'chatbot/types';
import { Direction, Level } from 'theme/enums';

interface IProps {
  title?: string;
  parts: IChatbotPart[];
  onUseThisBom?: (parts: IChatbotPart[]) => void;
}

export const ConversationParts = ({ title, parts, onUseThisBom }: IProps) => {
  const { t } = useTranslation();

  const columns = [
    ImportHeader.ITEM,
    ImportHeader.MANUFACTURER,
    ImportHeader.NUMBER,
    ImportHeader.QUANTITY,
    ImportHeader.UOM,
    ImportHeader.DESCRIPTION,
  ];

  const records = useMemo(() => {
    return parts.map((part) => ({
      id: Math.random(),
      item: part.item,
      manufacturer: part.manufacturer,
      number: part.partNumber,
      quantity: part.quantity,
      uom: part.uom,
      description: part.partDescription,
    }));
  }, [parts]);

  return (
    <Stack gap={2}>
      <Typography level={Level.TITLE_MD}>{title}</Typography>

      <Box sx={{ height: 450 }}>
        <PreviewImportTable
          type={ImportType.CUSTOMER_QUOTE}
          columns={columns}
          records={records}
          isDataLoading={false}
          loadingPercentage={100}
          dataCurrentPage={0}
          floatingFilter={false}
          rowHeight={48}
        />
      </Box>

      {onUseThisBom && (
        <Stack direction={Direction.ROW}>
          <Button onClick={() => onUseThisBom(parts)}>{t('buttonLabelUseThisBom')}</Button>
        </Stack>
      )}
    </Stack>
  );
};
